/**
 * Takes a string as seconds and returns an human readable string
 * @param {double, int} seconds
 * @returns
 */
export function formatDuration(
  seconds: number,
): `${string}:${string}:${string}` {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs
    .toString()
    .padStart(2, '0')}`
}
